import React from 'react';
import type { SubMenuType } from '../../components/SubMenu/SubMenuType';

type NavigationContextType = {
  onNavigate?: (id: SubMenuType) => void;
  onLogout?: () => void;
  popUpSpecialistWasClosed?: boolean;
  onClosePopUpSpecialist: () => void;
  onFinishOnboard: () => void;
  onboardIsFinished?: boolean;
};

const NavigationContext = React.createContext<NavigationContextType>({
  onClosePopUpSpecialist: () => {
    return null;
  },
  onFinishOnboard: () => {
    return null;
  },
});

export type NavigationProviderProps = Omit<
  NavigationContextType,
  | 'onClosePopUpSpecialist'
  | 'popUpSpecialistWasClosed'
  | 'onFinishOnboard'
  | 'onboardIsFinished'
> & {
  children: React.ReactNode;
};

export const NavigationProvider = ({
  onLogout,
  onNavigate,
  children,
}: NavigationProviderProps) => {
  const [popUpSpecialistWasClosed, setPopUpSpecialistWasClosed] =
    React.useState(false);
  const [onboardIsFinished, setOnboardIsFinished] = React.useState(false);

  const onClosePopUpSpecialist = () => {
    setPopUpSpecialistWasClosed(true);
  };

  const onFinishOnboard = () => {
    return setOnboardIsFinished(true);
  };

  return (
    <NavigationContext.Provider
      value={{
        onLogout,
        onNavigate,
        onClosePopUpSpecialist,
        popUpSpecialistWasClosed,
        onFinishOnboard,
        onboardIsFinished,
      }}
    >
      {children}
    </NavigationContext.Provider>
  );
};

export const useNavigation = () => {
  return React.useContext(NavigationContext);
};
